import { ExporterPropertyBase, } from "./SDKExporterPropertyBase";
export class ExporterPropertyDefinitionObject extends ExporterPropertyBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        super(model);
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Public properties
        this.type = "Object";
        this.allowedKeys = (_a = model.allowedKeys) !== null && _a !== void 0 ? _a : null;
        this.defaultValues = model.default;
    }
}
